import { FC, useEffect, useRef, useState } from "react";
import moment from "moment";

interface PageFooterProps {
  className?: string;
}

const PageFooter: FC<PageFooterProps> = (props: PageFooterProps) => {
  const currentYear = useRef(new Date().getFullYear());
  const [lastLoggedInDate, setLastLoggedInDate] = useState("N/A");

  useEffect(() => {
    // jest doesn't recognize cookieStore at this time
    // possibly because it's not supported outside https
    if (!window.cookieStore) return;

    cookieStore.get("LastLoggedInDate").then((cookie) => {
      if (!cookie) return;

      const date = moment.utc(decodeURIComponent(cookie.value));
      if (date.isValid()) {
        setLastLoggedInDate(date.local().format("L LT"));
      } else {
        setLastLoggedInDate("N/A");
      }
    }, () => {
      // for rejected .get
      setLastLoggedInDate("N/A");
    }).catch(() => {
      // for errors in the resolved block
      setLastLoggedInDate("N/A");
    });
  }, []);

  const classes = `footer page-inner ${props.className || ""}`;

  return (
    <footer className={classes}>
      <hr className="mtb0" />
      <p className="text-muted"><small><strong>Copyright &copy; 2003-{currentYear.current} Quest Analytics, L.L.C. All rights reserved.</strong>&nbsp;&nbsp;Version&nbsp;{window.buildVersion}&nbsp;&nbsp;Last Login Date: {lastLoggedInDate} </small></p>
    </footer>
  );
}

export default PageFooter;